import type { PropsWithChildren } from 'react';
import { cn } from '../utils';

type SectionContainerProps = PropsWithChildren<{
  className?: string;
}>;

export function SectionContainer({ children, className }: SectionContainerProps) {
  return (
    <div className={cn('mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-10 xl:px-16', className)}>
      {children}
    </div>
  );
}
